import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { LoginForm } from '../components/auth/LoginForm';

export default function LoginPage() {
  const { user, loading } = useAuth();

  // Redirect if already logged in
   if (loading) {
     return (
       <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-red-950 to-slate-900">
         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500"></div>
       </div>
     );
   }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return <LoginForm />;
}
